import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Observer, Subject, map } from 'rxjs';

// Local Models
import { ServicePathsSettings } from '../configuration/service-paths-settings';

@Injectable({
  providedIn: 'root',
})
export class FascicoliMappingService {
  tipiFascicolo: any;
  private subject = new Subject<any>();
  public notifyFascicoliSubject: Subject<any> = new Subject<any>();
  public notifyFascicoliObservable: Observable<
    any
  > = this.notifyFascicoliSubject.asObservable();

  constructor(private http: HttpClient) {}

  getListTipiFascicoloSubject(): Observable<any> {
    return this.subject.asObservable();
  }

  getAllTipiFascicolo(): Observable<any> {
    if (this.tipiFascicolo)
      return Observable.create((observer: Observer<any>) =>
        observer.next(this.tipiFascicolo)
      );
    return Observable.create((observer: Observer<any>) => {
      const url =
        ServicePathsSettings.DOMINIO +
        ServicePathsSettings.URL_ALL_TIPI_FASCICOLO;
      // const url = ServicePathsSettings.DOMINIO_API_GATEWAY + ServicePathsSettings.URL_ALL_TIPI_FASCICOLO_API_GATEWAY;
      this.http.get(url).subscribe((res) => {
        this.tipiFascicolo = res;
        observer.next(res);
        this.subject.next(res);
        this.notifyFascicoliSubject.next(res);
      });
    });
  }

  getTipiFascicolo(tipiPratica?: any): Observable<any> {
    const url = ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_ALL_TIPI_FASCICOLO;
    return this.http.get(url).pipe(
      map(res => {
        let obj = {tipiPratica: tipiPratica, tipiFascicolo: res};
        return obj
      })
    );
  }

  getLabelFascicoloByEndpoint(endpoint) {
    if (!this.tipiFascicolo) return;
    return this.tipiFascicolo.find((el) => el.endpoint === endpoint).label;
  }

  getIdFromLabelFascicolo(endpoint) {
    // debugger;
    if (!this.tipiFascicolo) return;
    return this.tipiFascicolo.find((el) => el.endpoint === endpoint).id;
    // return Number(Object.keys(this.tipiFascicolo).find(key => this.tipiFascicolo[key] === endpoint));
  }

  getTypeFromLabelFascicolo(endpoint) {
    // debugger;
    if (!this.tipiFascicolo) return;
    return this.tipiFascicolo.find((el) => el.endpoint === endpoint);
  }

  getLabelMenuBySectionFascicolo(list, id) {
    if (!list.length) {
      return;
    }
    if (list.find((el) => el.id === id)) {
      return list.find((el) => el.id === id).descrizione;
    }
    return;
  }

  getNextStepWizard(list, id) {
    if (!list.length) {
      return;
    }
    // debugger;
    let index = list.findIndex((el) => el.id === id);
    if (index > -1) {
      let findMenu = false;
      while (!findMenu) {
        if (!list[index + 1].disabled && list[index + 1].hide !== true) {
          findMenu = true;
          return '/' + list[index + 1].id;
        } else {
          index++;
          if (index === list.length + 1) {
            findMenu = true;
            return;
          }
        }
      }
    } else {
      return;
    }
  }
}
